import React from 'react';
import { Card, CardContent } from 'components/ui/card';
import { Icon } from 'components/ui/icon';
import useOrganisation from 'state/organisation/hooks/useOrganisation';
import CURRENCY from 'utils/currency';
import { formatToTz } from 'utils/date-format';
import { TRANSACTION_DETAILS_HEADINGS } from '../../../../utils/constants';
import { transactionStatusFormatter } from '../../../../utils/status-formatter';

export interface IOrderInfo {
  statementReference?: string;
  status?: string;
  amount?: number;
  createdAt?: string;
  charge: string;
}

interface prop {
  info: IOrderInfo;
}
const Orders = ({ info }: prop): JSX.Element => {
  const {
    organisation: { settings },
  } = useOrganisation();

  return (
    <>
      <Card className="mb-4 flex justify-center shadow-none">
        <CardContent className="pt-6">
          <div className="flex flex-wrap -mx-[15px]">
            <div className="flex-1 px-[15px]">
              You are currently viewing an order for which an ACH request has
              not been initiated. When this order is marked as ready/delievered,
              the ACH request will be initiated, and this order will move to the
              &apos;Payment initiated&apos; tab.
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="mb-5 shadow-none TransactionDetailsCard">
        <CardContent className="pt-6">
          <div className="flex flex-wrap -mx-[15px]">
            <div className="flex-1 px-[15px]">
              <h4>
                <Icon
                  name="dollar"
                  size={16}
                  className="text-gray-blue-60 pr-2"
                />
                Transaction Details
              </h4>
            </div>
            <div className="flex-1 px-[15px] flex justify-end">
              <h5 className="text-muted-foreground mb-0">{info.charge}</h5>
            </div>
          </div>

          <div className="flex flex-wrap -mx-[15px] mt-3 mb-3">
            <div className="flex-1 px-[15px]">
              <div className="card-text">
                <h5 className="text-muted-foreground mb-0">
                  {TRANSACTION_DETAILS_HEADINGS.HEADINGS_1}
                </h5>
                {CURRENCY.convertToMainUnit(info.amount)}
              </div>
            </div>
            <div className="flex-1 px-[15px]">
              <div className="card-text">
                <h5 className="text-muted-foreground mb-0">
                  {TRANSACTION_DETAILS_HEADINGS.HEADINGS_5}
                </h5>
                {info.statementReference}
              </div>
            </div>
            <div className="flex-1 px-[15px]">
              <div className="card-text">
                <h5 className="text-muted-foreground mb-0">
                  {TRANSACTION_DETAILS_HEADINGS.HEADINGS_2}
                </h5>
                {transactionStatusFormatter(info.status)}
              </div>
            </div>
          </div>
          <div className="flex flex-wrap -mx-[15px] mt-3 mb-3"></div>
          <div className="flex flex-wrap -mx-[15px] mt-3 mb-3">
            <div className="flex-1 px-[15px]">
              <div className="card-text">
                <h5 className="text-muted-foreground mb-0">
                  {TRANSACTION_DETAILS_HEADINGS.HEADINGS_3}
                </h5>
                {info.createdAt &&
                  formatToTz(
                    info.createdAt,
                    settings?.timezone,
                    'MMM dd yyyy, HH:mm'
                  )}
              </div>
            </div>
            <div className="flex-1 px-[15px]"></div>

            <div className="flex-1 px-[15px]"></div>
          </div>
          <div className="flex flex-wrap -mx-[15px] mt-3 mb-3">
            <div className="flex-1 px-[15px]" />
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default Orders;
